import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Permission } from './model/user';

@Injectable({ providedIn: 'root' })
export class PanelGuard {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const panel = route.data?.['panel'] as string | undefined;
    if (!panel) return true;

    const action = (route.data?.['action'] ?? 'can_read') as keyof Permission;

    if (this.authService.hasPanel(panel, action)) {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
}
